"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDatePicker = void 0;
var react_1 = __importDefault(require("react"));
var FormField_1 = require("../FormField");
var DatePicker_1 = require("../DatePicker");
var FormDatePicker = function (_a) {
    var control = _a.control, disabled = _a.disabled, error = _a.error, maskProps = _a.maskProps, maxDate = _a.maxDate, minDate = _a.minDate, onChange = _a.onChange, size = _a.size, value = _a.value, placeholder = _a.placeholder, props = __rest(_a, ["control", "disabled", "error", "maskProps", "maxDate", "minDate", "onChange", "size", "value", "placeholder"]);
    var formFieldProps = __assign({ disabled: disabled,
        error: error }, props);
    var datePickerProps = {
        disabled: disabled,
        maskProps: maskProps,
        maxDate: maxDate,
        minDate: minDate,
        onChange: onChange,
        size: size,
        value: value,
        placeholder: placeholder,
        error: Boolean(error),
    };
    return (react_1.default.createElement(FormField_1.FormField, __assign({}, formFieldProps),
        react_1.default.createElement(DatePicker_1.DatePicker, __assign({}, datePickerProps))));
};
exports.FormDatePicker = FormDatePicker;
//# sourceMappingURL=FormDatePicker.js.map